<template>
  <v-dialog v-model="open" :max-width="maxWidth" :persistent="persistent">
    <v-card color="secondary" class="rounded-xl">
      <v-card-title v-if="title" class="text-h6 pa-6">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="$slots.default" class="pa-6">
        <slot />
      </v-card-text>
      <v-card-text v-else-if="message" class="pa-6">
        <p class="mb-0">{{ message }}</p>
      </v-card-text>
      <v-card-actions class="pa-6 pt-2">
        <v-spacer />
        <v-btn
          :color="cancelColor"
          :variant="cancelVariant"
          :size="cancelSize"
          @click="handleCancel"
          class="rounded-lg"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="confirmColor"
          :variant="confirmVariant"
          :size="confirmSize"
          @click="handleConfirm"
          class="rounded-lg"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: "Confirmation" },
  message: { type: String, default: "" },
  confirmText: { type: String, default: "Confirmer" },
  cancelText: { type: String, default: "Annuler" },
  confirmColor: { type: String, default: "error" },
  cancelColor: { type: String, default: "on-surface" },
  confirmVariant: { type: String, default: "elevated" },
  cancelVariant: { type: String, default: "text" },
  confirmSize: { type: String, default: "default" },
  cancelSize: { type: String, default: "default" },
  maxWidth: { type: [String, Number], default: 420 },
  persistent: { type: Boolean, default: false },
  closeOnConfirm: { type: Boolean, default: true },
  closeOnCancel: { type: Boolean, default: true },
});

const emit = defineEmits(["update:modelValue", "confirm", "cancel"]);

const open = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

function handleConfirm() {
  emit("confirm");
  if (props.closeOnConfirm) {
    emit("update:modelValue", false);
  }
}

function handleCancel() {
  emit("cancel");
  if (props.closeOnCancel) {
    emit("update:modelValue", false);
  }
}
</script>
